module.exports = __webpack_public_path__ + "img/010-cat.efcf74dc.svg";